'use client';

import * as React from 'react';
import type {FeatureFlagName} from '@packages/systems/feature-config/shared';
import {onUpdate} from './observers';

export type FlagMap = Partial<Record<FeatureFlagName, boolean>>;
type FeatureConfigContextT = {userUpdated: number; overrides: FlagMap};

export const FeatureConfigContext = React.createContext<FeatureConfigContextT>({
  userUpdated: -1,
  overrides: {},
});

export const FeatureConfigProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [context, setContext] = React.useState<FeatureConfigContextT>({
    userUpdated: 0,
    overrides: {},
  });
  React.useEffect(
    () =>
      onUpdate(() =>
        setContext(({userUpdated, overrides}) => ({
          userUpdated: userUpdated + 1,
          overrides,
        }))
      ),
    []
  );

  return (
    <FeatureConfigContext.Provider value={context}>
      {children}
    </FeatureConfigContext.Provider>
  );
};
